module.exports = __webpack_public_path__ + "static/media/c1.85cf8fe9.png";